import {forwardRef, useState} from 'react';

import {Icon} from '#component/base';
import {TextInputField, TextInputFieldProps} from '#component/partial/TextInputField';
import {sprinkles} from '#style/sprinkles';

export const PasswordInputField = forwardRef<HTMLInputElement, TextInputFieldProps>(
  ({...otherProps}, ref) => {
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);

    const handleToggleVisibility = () => {
      setIsPasswordVisible(isVisible => !isVisible);
    };

    return (
      <TextInputField
        {...otherProps}
        ref={ref}
        rightContent={
          <button
            aria-pressed={isPasswordVisible}
            className={sprinkles({p: 8})}
            onClick={handleToggleVisibility}
            type="button">
            <Icon
              aria-label="Toggle Password Visibility"
              name={isPasswordVisible ? 'Eye' : 'EyeSlash'}
              weight="bold"
              color="silver"
            />
          </button>
        }
        type={isPasswordVisible ? 'text' : 'password'}
      />
    );
  },
);
